import React from 'react';
import CountUp from 'react-countup';

import {
  Section, ContactSection, Container,
} from 'components';
import { CoupleCount } from 'variables';
import { services } from './data';
import {
  InstallWrapper, InstallButton,
  Wrapper, Item, Content, Image,
} from './style';

const About: React.FC = _ => {
  return (
    <div>
      <Section minHeight={250}>
        <h1>데이트코스 앱 분야 국내 1위<br/>누적 다운로드 <CountUp end={CoupleCount} duration={1.5} separator={','} />만</h1>
        <InstallWrapper>
          <InstallButton
            href="https://play.google.com/store/apps/details?id=com.tenfingers.seouldatepop&hl=ko"
            target="_blank"
            rel="noopener noreferrer"
          >
            Android
          </InstallButton>
          <InstallButton
            href="https://itunes.apple.com/kr/app/deiteupab/id815000358?mt=8"
            target="_blank"
            rel="noopener noreferrer"
          >
            iOS
          </InstallButton>
        </InstallWrapper>
      </Section>

      <Container>
        <Wrapper>
          {services.map((service, i) => {
            return (
              <Item
                key={i}
              >
                <Content>
                  <h1>{`0${i + 1}`}</h1>
                  <h1>{service.title}</h1>
                  <p>{service.content}</p>
                </Content>
                <Image src={service.image} alt="서비스" />
              </Item>
            );
          })}
        </Wrapper>
      </Container>

      <ContactSection />
    </div>
  );
};

export default About;
